(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
(() => {
  const ready = new WeakSet();
  const setup = () => document.querySelectorAll('[data-carousel]').forEach(carousel => {
    if (ready.has(carousel)) return;
    ready.add(carousel);
    const track = carousel.querySelector('[data-carousel-track]');
    const prev = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      prev.hidden = next.hidden = max <= 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    };
    const move = direction => {
      const card = track.firstElementChild;
      if (!card) return;
      const step = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
      const count = Math.max(1, Math.floor((track.clientWidth + 2) / step));
      track.scrollBy({left:direction * step * count, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    };
    prev.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', update, {passive:true});
    new ResizeObserver(update).observe(track);
    update();
  });
  new MutationObserver(setup).observe(document.body, {childList:true, subtree:true});
  setup();
})();

  } catch(e) { console.error(e); }
})();
})();
